import { useNavigate, useLocation } from "react-router-dom";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { locales } from "@/lib/i18n/config";
import { Combobox } from "@a2z/ui";

export function LanguageSelect({ currentLocale }: { currentLocale: string }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const t = useTranslations();

  const options = [
    { value: "ar", label: t(keys.common.languageArabic) },
    { value: "en", label: t(keys.common.languageEnglish) },
  ];

  const handleChange = (nextLocale: string | null) => {
    if (!nextLocale || nextLocale === currentLocale) return;
    const path = pathname ?? "/";
    const localePattern = new RegExp(`^/(${locales.join("|")})(/|$)`);
    const nextPath = localePattern.test(path)
      ? path.replace(localePattern, `/${nextLocale}$2`)
      : `/${nextLocale}${path.startsWith("/") ? "" : "/"}${path}`;

    navigate(nextPath, { replace: true });
  };

  return (
    <label className="flex w-full flex-col gap-2 text-xs font-semibold text-[color:var(--text-muted)]">
      <span>{t(keys.common.language)}</span>
      <Combobox
        options={options}
        value={currentLocale}
        onChange={handleChange}
        aria-label={t(keys.common.language)}
      />
    </label>
  );
}
